import { writable } from 'svelte/store';

// localStorage-backed writable store
export function persistedWritable<T>(key: string, initialValue: T) {
  let stored: T = initialValue;
  if (typeof localStorage !== 'undefined') {
    const raw = localStorage.getItem(key);
    if (raw !== null) {
      try {
        stored = JSON.parse(raw);
      } catch {
        /* use initial */
      }
    }
  }
  const store = writable<T>(stored);
  store.subscribe((value) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(value));
    }
  });
  return store;
}
